var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundoffD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54541 36.4203C6.54541 35.849 35.2939 7.67188 35.2939 7.67188",
    stroke: "black",
    strokeWidth: 0.948,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4536 31.9995C22.5037 31.799 22.5338 31.4181 22.5338 30.8668V29.8945L22.5138 12.9241C23.436 13.5355 24.6689 14.0969 26.2326 14.6081C27.7663 15.1293 28.5281 15.8109 28.5281 16.6429C28.5281 17.1842 28.2274 17.8257 27.6259 18.5775L28.1071 19.3694C29.6908 17.8257 30.4827 16.4725 30.4827 15.3198C30.4827 13.5556 28.7987 12.1723 25.4407 11.1599C24.4584 10.8491 23.7868 10.5484 23.436 10.2377C23.0851 9.92692 22.7644 9.38564 22.4636 8.59375L21.2908 8.65389V30.1651C19.9777 29.0324 18.6145 28.4611 17.2111 28.4611C15.6474 28.4611 14.3142 28.7718 13.1916 29.3832C12.0689 29.9947 11.5176 30.7365 11.5176 31.6085C11.5176 33.6835 13.3018 34.7159 16.8703 34.7159C18.4441 34.7159 19.7171 34.4553 20.6994 33.9341C21.6718 33.4028 22.2632 32.7613 22.4536 31.9995Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42.6484C9.42243 42.6484 0 33.226 0 21.6484C0 10.0709 9.42243 0.648438 21 0.648438C32.5776 0.648438 42 10.0709 42 21.6484C42 33.226 32.5776 42.6484 21 42.6484ZM21 2.03173C10.1842 2.03173 1.38329 10.8327 1.38329 21.6484C1.38329 32.4642 10.1842 41.2651 21 41.2651C31.8158 41.2651 40.6167 32.4642 40.6167 21.6484C40.6267 10.8327 31.8158 2.03173 21 2.03173Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundoffD);
export default __webpack_public_path__ + "static/media/soundoff_d.697518b7d79610e96cdf71dbbcfef562.svg";
export { ForwardRef as ReactComponent };